import { useCallback, useMemo } from 'react';

import type { URLSearchParamsInit } from 'react-router-dom';
import { useSearchParams } from 'react-router-dom';

import { getCurrentWeek } from 'utils/date';

const DEFAULT_PAGE_SIZE = 10;
const DEFAULT_PAGE = 1;

interface UsePlannerSearchParamsType {
  currentSearchParams: Record<string, string>;
  searchParams: URLSearchParams;
  setSearchParams: (
    nextInit: URLSearchParamsInit,
    navigateOptions?:
      | {
          replace?: boolean | undefined;
          state?: unknown;
        }
      | undefined,
  ) => void;
}

const usePlannerSearchParams = (): UsePlannerSearchParamsType => {
  const currentWeek = useMemo(getCurrentWeek, []);
  const [searchParams, setRouterSearchParams] = useSearchParams({
    fromDate: currentWeek[0].format('YYYY-MM-DD'),
    pageNumber: DEFAULT_PAGE.toString(),
    pageSize: DEFAULT_PAGE_SIZE.toString(),
    tableFromDate: currentWeek[0].format('YYYY-MM-DD'),
    tableToDate: currentWeek[1].format('YYYY-MM-DD'),
    toDate: currentWeek[1].format('YYYY-MM-DD'),
    viewType: 'grid',
  });

  const currentSearchParams: Record<string, string> = useMemo(() => {
    const result: Record<string, string> = {};
    searchParams.forEach((v, k) => {
      result[k] = v;
    });
    return result;
  }, [searchParams]);

  const setSearchParams = useCallback(
    (
      nextInit: URLSearchParamsInit,
      navigateOptions?:
        | {
            replace?: boolean | undefined;
            state?: unknown;
          }
        | undefined,
    ) => {
      setRouterSearchParams(nextInit, {
        replace: true,
        ...navigateOptions,
      });
    },
    [setRouterSearchParams],
  );

  return {
    currentSearchParams,
    searchParams,
    setSearchParams,
  };
};

export default usePlannerSearchParams;
